import { FC } from 'react';
import styled from 'styled-components';
import { media, SPACES } from '@belong/themes';
import { IRichText, ITestable } from '@belong/types';
import { ListItem, OrderedList } from '../List';
import { Copy, RichText } from '../Typography';

const StyledFootnote = styled(OrderedList)`
  padding-top: ${SPACES.small}rem;

  /* So the user can focus on the element */
  li > * {
    z-index: -1;
  }

  ${media('md')`
      padding-top: ${SPACES.medium}rem;
  `}
`;

interface IFootnotes extends ITestable {
  /*
   * The footnote id needs to be the start of the hash for all footnote links within the table
   *
   * footnoteId: 'footnote'
   *
   * The links within the table need to have the hash set to the footnoteId followed by a hyphen and footnote position
   * eg 'footnote-1'. If there are multiple footnotes it will be 'footnote-1','footnote-2', etc
   */
  footnoteId: string;
  footnotes: Array<IRichText | string>;
}

export const Footnotes: FC<IFootnotes> = ({ footnotes, footnoteId, 'data-testid': dataTestId = footnoteId }) => (
  <StyledFootnote data-testid={dataTestId}>
    {footnotes.map((footnote, footnoteIdx) => {
      const id = `${footnoteId}-${footnoteIdx + 1}`;

      return (
        <ListItem key={id}>
          {typeof footnote === 'string' ? <Copy id={id}>{footnote}</Copy> : <RichText {...footnote} id={id} />}
        </ListItem>
      );
    })}
  </StyledFootnote>
);

Footnotes.displayName = 'Footnote';
